import { patch } from '../axios'

interface RemoveWishlistProps {
  userId: number
  productId: number
  operation?: string
}

const removeWishlist = async ({
  userId,
  productId,
  operation,
}: RemoveWishlistProps) => {
  const url = '/hyperlocal/v1/wishlist/update'
  try {
    await patch(url, {
      user_id: userId,
      product_id: productId,
      operation: operation || 'REMOVED',
    })
    return true
  } catch (e) {
    console.error(e)
    return false
  }
}

export default removeWishlist
